export const lazerData = [
  {
    id: 1,
    img: 'lazertag/1.png',
    title: 'MP-9 LT «ФЕНИКС»',
    desc: [
      {
        id: 1,
        title: 'Класс — пистолет-пулемет',
      },
      {
        id: 2,
        title: 'Масса — 0,68 кг',
      },
      {
        id: 3,
        title: 'Дальность стрельбы —  200 м',
      },
      {
        id: 4,
        title: 'Подходит для игроков — от 6 лет',
      },
    ],
  },
  {
    id: 2,
    img: 'lazertag/2.png',
    title: 'Повязка 9-го поколения',
    desc: [
      {
        id: 1,
        title: 'угол поражения - 360°',
      },
      {
        id: 2,
        title: 'Масса — 220 граммов',
      },

      {
        id: 3,
        title: 'Подходит для игроков — от 6 лет',
      },
    ],
  },
  {
    id: 3,
    img: 'lazertag/3.png',
    title: 'АК-12LT «ХИЩНИК»',
    desc: [
      {
        id: 1,
        title: 'Класс — штурмовая винтовка',
      },
      {
        id: 2,
        title: 'Масса — 1 кг',
      },
      {
        id: 3,
        title: 'Дальность стрельбы —  250 м',
      },
      {
        id: 4,
        title: 'Подходит для игроков — от 7 лет',
      },
    ],
  },
  {
    id: 4,
    img: 'lazertag/4.png',
    title: 'Базовая аптечка',
    desc: [
      {
        id: 1,
        title:
          'Основные функции «аптечек» оживление «убитых», полное восстановление их жизненных сил и боезапаса',
      },
    ],
  },
  {
    id: 5,
    img: 'lazertag/5.png',
    title: 'Лазертаг-бомба «КРАТЕР»',
    desc: [
      {
        id: 1,
        title:
          'Радиус поражения: до 15 метров в помещении за счет большого рикошета от потолка',
      },
    ],
  },
  {
    id: 6,
    img: 'lazertag/6.png',
    title: 'MP-665K',
    desc: [
      {
        id: 1,
        title: 'Класс — пистолет',
      },
      {
        id: 2,
        title: 'Масса — 520 г',
      },
      {
        id: 3,
        title: 'Дальность стрельбы —  30 м',
      },
      {
        id: 4,
        title: 'Подходит для игроков — от 7 лет',
      },
    ],
  },
  {
    id: 7,
    img: 'lazertag/7.png',
    title: '«HITMAN»',
    desc: [
      {
        id: 1,
        title: 'Класс — пистолет',
      },
      {
        id: 2,
        title: 'Масса — 720 г',
      },
      {
        id: 3,
        title: 'Дальность стрельбы —  50 м',
      },
      {
        id: 4,
        title: 'Подходит для игроков — от 7 лет',
      },
    ],
  },
  {
    id: 8,
    img: 'lazertag/8.png',
    title: 'MP-9 LT «ФЕНИКС»',
    desc: [
      {
        id: 1,
        title:
          '3 основных сценария: «Захват контрольной точки», «Точка Battlefield», «Командный центр».',
      },
    ],
  },
  {
    id: 9,
    img: 'lazertag/9.png',
    title: 'МР-514 «TERMINATOR»',
    desc: [
      {
        id: 1,
        title: 'Класс — штурмовая винтовка',
      },
      {
        id: 2,
        title: 'Масса — 2.5 кг',
      },
      {
        id: 3,
        title: 'Дальность стрельбы —  250 м',
      },
      {
        id: 4,
        title: 'Подходит для игроков — от 12 лет',
      },
    ],
  },
];
export const pentData = [
  {
    id: 1,
    img: 'peinboll/1.png',
    title: 'Маркер Empire BT4',
    desc: [
      {
        id: 1,
        title: 'Колибр - 0.68',
      },
      {
        id: 2,
        title: 'Масса — 3 кг',
      },
      {
        id: 3,
        title: 'Длина ствола — 8 дюймов',
      },
    ],
  },
  {
    id: 2,
    img: 'peinboll/2.png',
    title: 'Камуфляж куртка и штаны',
    desc: [
      {
        id: 1,
        title: 'Размер S/M, L/XL',
      },
    ],
  },
  {
    id: 3,
    img: 'peinboll/3.png',
    title: 'Броник',
    desc: [
      {
        id: 2,
        title: 'Масса — 1 кг',
      },
    ],
  },
  {
    id: 4,
    img: 'peinboll/4.png',
    title: 'Маска Empire',
    desc: [
      {
        id: 1,
        title:
          'Самая популярная пейнтбольная маска прокатного уровня с термальной линзой',
      },
    ],
  },
  {
    id: 5,
    img: 'peinboll/5.png',
    title: 'Шары для пейнтбола',
    desc: [
      {
        id: 1,
        title: 'Колибр - 0.68',
      },
    ],
  },
];
export const gidraData = [
  {
    id: 1,
    img: 'gidraboll/1.png',
    title: 'Орбиз автомат JM Scar',
    desc: [
      {
        id: 1,
        title: 'Калибр шаров - 7-8 мм',
      },
      {
        id: 2,
        title: 'Масса — 1,5 кг',
      },
      {
        id: 4,
        title: 'Подходит для игроков — от 10 лет',
      },
    ],
  },
  {
    id: 2,
    img: 'gidraboll/2.png',
    title: 'Зашитные очки',
    desc: [
      {
        id: 2,
        title: 'Масса — 70 граммов',
      },
    ],
  },
  {
    id: 3,
    img: 'gidraboll/3.png',
    title: 'Гидрогелевые шарики,',
    desc: [
      {
        id: 1,
        title: 'Калибр шаров - 7-8 мм',
      },
    ],
  },
];
